<template>
  <div>

  </div>
</template>
<script>
import api from '@ca/api'
import cookie from '@/utils/cookie'

export default {
  mounted () {
    api.logout().then(res => {
      this.$store.dispatch('clearProfile')
      const domain = window.location.host.split('.').splice(1).join('.')
      cookie.delCookie('Authnized', '.' + domain)
      cookie.delCookie('showImprove', '.' + domain)
      this.$router.replace({
        path: '/live'
      })
    })
    window.localStorage.clear()
  }
}
</script>
